// ⚠️ This file is an artifact: DO NOT MODIFY
export default {
    error: () => import(/* webpackIgnore: true */ "./plugins/error.js"),
};
